<template>
  <div class="pages-body contact-page flex flex-column">
    <div style="background-color: #2196f3" class="topbar p-3 flex justify-content-between flex-row align-items-center">
      <router-link class="topbar-left ml-2 flex" to="/">
        <div class="logo">
          <div style="font-weight: 400; line-height: 1.1; height: 2rem; color: #fff; font-size:20px" class="ml-2">
            {{ $t('anonymous.title') }}
          </div>
        </div>
      </router-link>
    </div>


    <div class="pages-panel" style="top: 11%; width: 85%;">
      <div class="card grid">
        <div class="left-panel lg:col-6 md:col-6 sm:col-12">
          <div class="survey">
            <div v-if="courseName"><b>{{ $t('subject') }}</b> {{ courseName }}</div>
            <div v-if="instructorName"><b>{{ $t('instructor') }}</b> {{ instructorName }}</div>
            <br/>

            <Form ref="form" style="margin-top: 2rem" @submit.prevent="submitForm">
              <div v-for="(field, index) in fields" :key="index">
                {{ $t(field.label) }}
                <br/>

                <div style="margin-top: 1rem; text-align:center;" v-if="field.type === 'rating'">
                  <VRating v-model="field.value" :cancel="false"/>
                  <p>{{ ratingDescription(field.value) }}</p>
                </div>
                <div style="margin-top: 1rem; text-align:center;" v-else>
                  <VSelectButton v-model="field.value" optionLabel="name" :options="[
                      { name: $t('option_no'), value: false },
                      { name: $t('option_yes'), value: true },
                    ]" aria-labelledby="basic"/>

                </div>
                <br/>
              </div>

              <Textarea v-model="comment" rows="5" style="width: 100%" :placeholder="$t('additional_comments')"/>
              <br/>
              <br/>

              <Button style="text-align:center; width: 100%" type="submit" :label="$t('submit')"/>

            </Form>

            <Toast ref="toast"/>
          </div>
        </div>
        <div class="right-panel lg:col-6 md:col-6 sm:col-12 mx-auto">


          <div class="md:col-offset-3 md:col-6 md:col-offset-3 sm-offset-2 sm:col-8">
            <i class="pi pi-check-circle text-blue-500 mb-2 mt-5"></i>
            <p class="title my-3">{{ $t('successful_visit') }}</p>
            <p>{{ $t('visit_success_text') }}</p>

            <i class="pi pi-eye-slash text-blue-500 mb-2 mt-5"></i>
            <p class="title my-3">{{ $t('anonymity') }}</p>
            <p>{{ $t('anonymity_text') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import axiosClient from "@/axios";
import VRating from "@/primevue/rating/Rating.vue";
import VSelectButton from "@/primevue/selectbutton/SelectButton.vue";

export default {
  components: {
    VRating,
    VSelectButton
  },
  data() {
    return {
      courseName: '',
      instructorName: '',
      fields: [
        {
          id: 'audience_interest',
          label: this.$t('fields.can_instructor_stimulate_interest'),
          type: 'switch',
          value: null
        },
        {id: 'objective_evaluation', label: this.$t('fields.is_instructor_objective'), type: 'switch', value: null},
        {id: 'good_behavior', label: this.$t('fields.is_instructor_friendly'), type: 'switch', value: null},
        {id: 'timely_session', label: this.$t('fields.is_lecture_timely'), type: 'switch', value: null},
        {id: 'session_rating', label: this.$t('fields.rate_the_lecture'), type: 'rating', value: null}
      ],
      comment: ''
    }
  },
  methods: {
    ratingDescription(rating) {
      switch (rating) {
        case 1:
          return this.$t('rating.very_bad'); // '1 балл – очень плохо'
        case 2:
          return this.$t('rating.bad'); // '2 балла – плохо'
        case 3:
          return this.$t('rating.satisfactory'); // '3 балла – удовлетворительно'
        case 4:
          return this.$t('rating.good'); // '4 балла – хорошо'
        case 5:
          return this.$t('rating.excellent'); // '5 баллов – отлично'
        default:
          return '';
      }
    },
    fetchCourseData() {
      const bookingId = this.$route.params.bookingId
      return axiosClient.get(`/bookings/${bookingId}`)
        .then((response) => {
          this.courseName = response.data.subject.SubjectNameRU
          this.instructorName = response.data.teacher.full_name
        })
    },
    submitForm() {
      if (this.fields.some(field => field.value === null)) {
        this.$refs.toast.add({severity: 'error', summary: 'Пожалуйста, оцените все аспекты курса.'})
        return
      }


      // Combine ratings and comment into a single formData object
      const formData = this.fields.reduce((obj, field) => {
        obj[field.id] = field.value.value ?? field.value;
        return obj;
      }, {});
      // Combine ratings and comment into a single formData object
      formData['booking_id'] = this.$route.params.bookingId;
      formData['comments'] = this.comment;
      return axiosClient.post(`/survey_answers`, {...formData})
        .then(() => {
          this.$refs.toast.add({severity: 'success', summary: 'Спасибо за ваш отзыв!'})
          setTimeout(() => {
            // Redirect to the success page
            this.$router.push('/success');
          }, 2000);
        });
    }
  },
  mounted() {
    this.fetchCourseData()
  }
}
</script>

<style scoped>
.survey {
  /* Your styles here */
}
</style>
